import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function Contact() {
  const { t } = useTranslation();

  const email = useMemo(() => {
    const u = atob("YWxleGFuZGVy");
    const d = atob("YXByZWxraW4uY29t");
    return `${u}@${d}`;
  }, []);

  const mobile   = "+49 174 34 10 721";
  const linkedin = "https://www.linkedin.com/in/aprelkin/";
  const mailto   = `mailto:${email}`;

  return (
    <section id="contact" className="contact-section py-5">
      <div className="container">
        <div className="text-center mb-0">
          <h2 className="mb-0">{t('contact.heading')}</h2>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-inner">
              <div className="contact-line">
                <span className="contact-k">{t('contact.email')}</span>
                <a href={mailto} className="contact-v">{email}</a>
              </div>
              <div className="contact-line">
                <span className="contact-k">{t('contact.mobile')}</span>
                <span className="contact-v">{mobile}</span>
              </div>
              <div className="contact-line">
                <span className="contact-k">{t('contact.linkedin')}</span>
                <a href={linkedin} className="contact-v" target="_blank" rel="noreferrer">
                  {t('contact.profile')}
                </a>
              </div>
              <div className="contact-mini text-muted">{t('contact.availability')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
